import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { OptionsAdminService } from '../../services/options-admin.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { BrowserWidthService } from '../../services/browser-width.service';
import { HttpResponseService } from '../../services/httpresponse-service';

import { Option } from '../../model/option';
import { SubOption } from '../../model/suboption';
import { AdminOption } from '../../model/admin-option';
import { AdminOptionCategory } from '../../model/admin-option-category';
import { ProductLine } from '../../model/product-line';

import * as _ from 'lodash';

@Component({
    selector: 'options-admin-aside',
    template: require('./options-admin-aside.component.html'),
    styles: [require('./options-admin-aside.component.scss')]
})
export class OptionsAdminAsideComponent implements OnDestroy {
    currentPricingView: number;
    chosenProductLineId: number;
    chosenProductLineCode: string;
    selectedCategoryId: number;
    searchString: string;
    selectedPlantNumber: number;
    selectedPageNumber: number;
    userId: string;

    private _savedItem: Option;
    private _subOptionCache: SubOption[] = new Array<SubOption>();
    // private _productLineList: ProductLine[] = new Array<ProductLine>();

    option: Option;
    optionList: Option[];
    allOptions: Option[];
    categories: AdminOptionCategory[];

    showCancelEdit: boolean = false;
    resetClicked: boolean = false;
    visible: boolean = true;
    subscription: Subscription = new Subscription();

    constructor(
        public optionsAdminService: OptionsAdminService,
        public spinner: LoadingSpinnerService,
        public browserWidthService: BrowserWidthService,
        private httpResponseService: HttpResponseService
    ) {

        const userIdSub = this.optionsAdminService.userId$.subscribe(x => { this.userId = x; });
        this.subscription.add(userIdSub);

        const allCustomerCategoriesSub = this.optionsAdminService.allCustomerCategories$.subscribe(x => { this.categories = x; });
        this.subscription.add(allCustomerCategoriesSub);

        const pageoptionsSub = this.optionsAdminService.optionsadminasidePageOptions$.subscribe(x => {

            if (x !== undefined && x !== null) {

                this.chosenProductLineId = x.productLineId === 0 || x.productLineId === null || x.productLineId === undefined ?
                    undefined :
                    x.productLineId;
                this.chosenProductLineCode = x.productLineCode === undefined || x.productLineCode === null ? undefined : x.productLineCode;
                let currentProductLineCode = x.productLineCode === undefined || x.productLineCode === null ? undefined : x.productLineCode;
                let currentProductLineId = this.chosenProductLineId;

                this.selectedCategoryId = x.categoryId === undefined || x.categoryId === null ? undefined : x.categoryId;
                this.searchString = x.searchString === undefined || x.searchString === null ? undefined : x.searchString;
                this.selectedPageNumber = x.pageNumber === undefined || x.pageNumber === null ? 1 : x.pageNumber;
                this.selectedPlantNumber = x.plantNumber;
                // this._productLineList = x.option.ProductLines;

                // set option data
                if (x.option.OptionId !== undefined && x.option.OptionId !== null && x.option.OptionId !== 0) {
                    this.option = this.createUnreferencedOption(x.option);
                    this._savedItem = this.createUnreferencedOption(x.option);
                    this._subOptionCache = new Array<SubOption>();
                    this._subOptionCache = Object.assign(this._subOptionCache, this.option.SubOptions);


                    // default chosen product line to first in list
                    let pl = new ProductLine();
                    if (this.option.ProductLines !== undefined && this.option.ProductLines.length >= 0) {
                        pl = this.option.ProductLines[0];
                        if (currentProductLineCode === undefined) {
                            currentProductLineId = pl.ProductLineId;
                            currentProductLineCode = pl.ProductLineCode;

                            this.chosenProductLineCode = pl.ProductLineCode;
                            this.chosenProductLineId = pl.ProductLineId;
                        }
                    }
                    // override chosen product line if product line code specified
                    if (this.chosenProductLineCode !== undefined) {
                        pl = this.option.ProductLines.find(productLine => productLine.ProductLineCode === this.chosenProductLineCode);
                        if (pl !== undefined) {
                            this.option.ProductLineId = pl.ProductLineId;
                            this.option.ProductLineDesc = pl.ProductLineDescription;

                            currentProductLineId = pl.ProductLineId;
                            currentProductLineCode = pl.ProductLineCode;

                            this.chosenProductLineCode = pl.ProductLineCode;
                            this.chosenProductLineId = pl.ProductLineId;

                        }
                    }


                    // now select the suboptions to use based on product line
                    this.option.SubOptions =
                        this.option.SubOptions !== undefined && this.option.SubOptions !== null && this.option.SubOptions.length > 0 ?
                        this._subOptionCache.filter(so => so.ProductLineId === currentProductLineId) : new Array<SubOption>();

                    // set admin option and product line data
                    this.option.AdminOption = this.getUIAdminOption(this.option, currentProductLineId, currentProductLineCode);

                    this.visible = this.option.AdminOption !== undefined && this.option.AdminOption !== null ?
                        this.option.AdminOption.Visible :
                        true;

                }
                if (x.options !== undefined && x.options !== null) {
                    this.optionList = x.options;
                } else {
                    this.optionList = new Array<Option>()
                }
            }
        });
        this.subscription.add(pageoptionsSub);

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    validateSubOptionVisibility(): boolean {
        return this.option.SubOptions.length === 0 || this.option.SubOptions.filter(so => so.AdminOption.Visible).length > 0;
    }

    cancelEdit() {
        if (this.HasChanged()) {
            this.showCancelEdit = true;
            this.browserWidthService.modalActive$.next(true);
        } else {
            // reset applicable attributes
            this.option.SubOptions = this._savedItem.SubOptions;
            this.option.AdminOption = this._savedItem.AdminOption;
            this.option.OptionDescription = this._savedItem.OptionDescription;
            this.option.CategoryDesc = this._savedItem.CategoryDesc;

            this.optionsAdminService.showAdminAside$.next(false);
            this.showCancelEdit = false;
            this.browserWidthService.modalActive$.next(false);
        }
    }

    HasChanged(productLine?:number): boolean {
        let changes: boolean = false;
        productLine = productLine == undefined || productLine == null ? Number(this.chosenProductLineId) : productLine;

        if (this._savedItem !== undefined && this._savedItem !== null
            && this._savedItem.AdminOption !== undefined && this._savedItem.AdminOption !== null) {
            let adminOption = this._savedItem.AdminOptions.find(ao => ao.ProductLineId === Number(productLine));
            if (adminOption !== undefined) {
                if (this.option.AdminOption.WebCategoryId !== adminOption.WebCategoryId) {
                    return true;
                }
                if (
                    this.option.AdminOption.CustomerDesc !== adminOption.CustomerDesc &&
                    this.option.AdminOption.CustomerDesc !== this.option.AdminOption.CustomerBaseDesc
                ) {
                    return true;
                }
                if (this.option.AdminOption.CustomerCat !== adminOption.CustomerCat) {
                    return true;
                }
                if (this.option.AdminOption.MaxQuantity !== adminOption.MaxQuantity) {
                    return true;
                }
                if (this.option.AdminOption.Visible !== adminOption.Visible) {
                    return true;
                }
            } else {
                let newAdminOption = new AdminOption();

                if (this.option.AdminOption.WebCategoryId !== newAdminOption.WebCategoryId) {
                    return true;
                }
                if (
                    this.option.AdminOption.CustomerDesc !== newAdminOption.CustomerDesc &&
                    this.option.AdminOption.CustomerDesc !== this.option.AdminOption.CustomerBaseDesc
                ) {
                    return true;
                }
                if (this.option.AdminOption.CustomerCat !== newAdminOption.CustomerCat) {
                    return true;
                }
                if (this.option.AdminOption.MaxQuantity !== newAdminOption.MaxQuantity) {
                    return true;
                }
                if (this.option.AdminOption.Visible !== newAdminOption.Visible) {
                    return true;
                }
            }

            if (this.option.SubOptions !== undefined && this.option.SubOptions !== null && this.option.SubOptions.length > 0) {
                this.option.SubOptions.forEach((op) => {
                    this._savedItem.SubOptions.filter(
                        so => so.ProductLineId === Number(productLine) && so.SubOptionId === op.SubOptionId).forEach((si) => {
                            if (
                                op.AdminOption.CustomerDesc !== si.AdminOption.CustomerDesc ||
                                op.AdminOption.Visible !== si.AdminOption.Visible
                            ) {
                                changes = true;
                            }
                        }
                    );
                });
            }
        }
        return changes;
    }

    get lastOption(): boolean {
        if (this.allOptions !== undefined && this.allOptions !== null && this.allOptions.length > 1) {
            for (let i = 0; i < this.allOptions.length; i++) {
                if (this.allOptions[i].OptionId === this.option.OptionId
                    && this.allOptions[i].PlantId === this.option.PlantId
                    && this.allOptions[i].SelectedSubOption === this.option.SelectedSubOption) {
                    if (this.allOptions.length === (i + 1)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    cancelEditLeaveValues() {
        this.showCancelEdit = false;
        this.browserWidthService.modalActive$.next(false);
    }

    cancelEditResetValues() {
        if (this._savedItem !== undefined && this._savedItem !== null) {
            this.option.SubOptions = this._savedItem.SubOptions;
            this.option.SubOptionCount = this._savedItem.SubOptionCount;
        }
        this.optionsAdminService.showAdminAside$.next(false);
        this.resetClicked = false;
        this.showCancelEdit = false;
        this.browserWidthService.modalActive$.next(false);
        if (this._savedItem !== undefined && this._savedItem !== null
            && this._savedItem.AdminOption !== undefined && this._savedItem.AdminOption !== null) {
            this.option.AdminOption.CustomerDesc = this._savedItem.AdminOption.CustomerDesc;
            this.option.AdminOption.CustomerCat = this._savedItem.AdminOption.CustomerCat;
            this.option.AdminOption.MaxQuantity = this._savedItem.AdminOption.MaxQuantity;
            this.option.AdminOption.Visible = this._savedItem.AdminOption.Visible;

            if (this.option.SubOptions !== undefined && this.option.SubOptions !== null && this.option.SubOptions.length > 0) {
                this.option.SubOptions.forEach((op) => {
                    this._savedItem.SubOptions.forEach((so) => {
                        if (op.SubOptionId === so.SubOptionId) {
                            op.AdminOption.CustomerDesc = so.AdminOption.CustomerDesc;
                        }
                    });
                });
            }
        }
    }

    reset() {
        if (this.option !== undefined && this.option !== null
            && this.option.AdminOption !== undefined && this.option.AdminOption !== null) {
            this.option.AdminOption.WebCategoryId = 0;
            this.option.AdminOption.CustomerDesc = '';
            this.option.AdminOption.CustomerCat = '';
            this.option.AdminOption.MaxQuantity = 0;
            this.option.AdminOption.Visible = true;

            if (this.option.SubOptions !== undefined && this.option.SubOptions !== null && this.option.SubOptions.length > 0) {
                this.option.SubOptions.forEach((op) => {
                    if (op.AdminOption !== undefined && op.AdminOption !== null) {
                        op.AdminOption.CustomerDesc = '';
                        op.AdminOption.Visible = true;
                    }
                });
            }
        }
        if (this._savedItem !== undefined && this._savedItem !== null
            && this._savedItem.AdminOption !== undefined && this._savedItem.AdminOption !== null) {
            this._savedItem.AdminOption.WebCategoryId = 0;
            this._savedItem.AdminOption.CustomerDesc = '';
            this._savedItem.AdminOption.CustomerCat = '';
            this._savedItem.AdminOption.MaxQuantity = 0;
            this._savedItem.AdminOption.Visible = true;

            if (this._savedItem.SubOptions !== undefined && this._savedItem.SubOptions !== null && this._savedItem.SubOptions.length > 0) {
                this._savedItem.SubOptions.forEach((op) => {
                    if (op.AdminOption !== undefined && op.AdminOption !== null) {
                        op.AdminOption.CustomerDesc = '';
                        op.AdminOption.Visible = true;
                    }
                });

                this.option.SubOptions = this._savedItem.SubOptions.filter(x => x.ProductLineId === Number(this.chosenProductLineId));
                this.option.SubOptionCount =
                    this._savedItem.SubOptions.filter(x => x.ProductLineId === Number(this.chosenProductLineId)).length;
            }
        }
    }

    save(next: boolean) {
        this.spinner.showSpinner();
        let adminOptions: AdminOption[] = new Array<AdminOption>();

        if (this.option !== undefined && this.option !== undefined) {

            adminOptions = this._buildAdminOptionForSave(this.chosenProductLineId);

            this.optionsAdminService.insUpdAdminOption(adminOptions, this.userId)
                .subscribe(
                (x => {
                    if (x !== undefined && x != null && x.Options !== undefined && x.Options !== null && x.Options.length > 0) {
                        // returned value from update is the option that was updated
                        let changedOption = x.Options.filter(o => o.OptionId === this.option.OptionId)[0];
                        changedOption.AdminOption = this.getUIAdminOption(changedOption, Number(this.chosenProductLineId));
                        this._savedItem = this.createUnreferencedOption(changedOption);
                        this.option = this.createUnreferencedOption(changedOption);
                        this.optionsAdminService.changedAdminOption$.next(this.createUnreferencedOption(changedOption));

                        if (next) {
                            if (this.optionList !== undefined && this.optionList !== null && this.optionList.length > 1) {
                                let currentIndex = this.optionList.findIndex(o => o.OptionId === this.option.OptionId);
                                if (currentIndex >= 0) {
                                    this.optionList[currentIndex] = this.option;
                                    if (this.optionList.length > (currentIndex + 1)) {
                                        if (
                                            this.optionList[currentIndex + 1].AdminOption === undefined ||
                                            this.optionList[currentIndex + 1].AdminOption === null
                                        ) {
                                            this.optionList[currentIndex + 1].AdminOption = new AdminOption();
                                        }

                                        let newOption = this.optionList[currentIndex + 1];
                                        this._savedItem = this.createUnreferencedOption(newOption);
                                        this.option = this.createUnreferencedOption(newOption);
                                        if (this._savedItem !== undefined && this._savedItem !== null) {
                                            if (this.option.SubOptions !== null && this.option.SubOptions !== undefined) {
                                                this.option.SubOptions = this.option.SubOptions.filter(
                                                    subOption => subOption.ProductLineId === Number(this.chosenProductLineId)
                                                );
                                                this.option.SubOptionCount = this.option.SubOptions.filter(
                                                    subOption => subOption.ProductLineId === Number(this.chosenProductLineId)
                                                ).length;
                                            } else {
                                                this.option.SubOptions = new Array<SubOption>();
                                                this.option.SubOptionCount = 0;
                                            }
                                        }
                                        this.option.AdminOption = this.getUIAdminOption(this.option, Number(this.chosenProductLineId));

                                        // this is set after update to correctly set current option product line
                                        if (this.chosenProductLineCode !== undefined) {
                                            let plIndex = this.option.ProductLines.findIndex(
                                                pl => pl.ProductLineCode.trim().toLocaleLowerCase() ===
                                                    this.chosenProductLineCode.trim().toLocaleLowerCase()
                                            );
                                            if (plIndex >= 0) {
                                                this.option.ProductLineId = this.option.ProductLines[plIndex].ProductLineId;
                                                this.option.ProductLineDesc = this.option.ProductLines[plIndex].ProductLineDescription;
                                                this.chosenProductLineId = this.option.ProductLines[plIndex].ProductLineId;
                                                this.chosenProductLineCode = this.option.ProductLines[plIndex].ProductLineCode;
                                            } else {
                                                this.option.ProductLineId = this.option.ProductLines[0].ProductLineId;
                                                this.option.ProductLineDesc = this.option.ProductLines[0].ProductLineDescription;
                                                this.chosenProductLineId = this.option.ProductLines[0].ProductLineId;
                                                this.chosenProductLineCode = this.option.ProductLines[0].ProductLineCode;
                                            }
                                        } else {
                                            this.option.ProductLineId = this.option.ProductLines[0].ProductLineId;
                                            this.option.ProductLineDesc = this.option.ProductLines[0].ProductLineDescription;
                                            this.chosenProductLineId = this.option.ProductLines[0].ProductLineId;
                                            this.chosenProductLineCode = this.option.ProductLines[0].ProductLineCode;
                                        }
                                        this.visible = this.option.AdminOption !== undefined && this.option.AdminOption !== null ?
                                            this.option.AdminOption.Visible :
                                            true;
                                    } else {
                                        let newOption = this.optionList[currentIndex];
                                        this._savedItem = this.createUnreferencedOption(newOption);

                                        this.optionsAdminService.showAdminAside$.next(false);
                                    }
                                } else {
                                    this.optionsAdminService.showAdminAside$.next(false);
                                }
                            } else {
                                this.optionsAdminService.showAdminAside$.next(false);
                            }
                        } else {

                            this.optionsAdminService.showAdminAside$.next(false);
                        }
                    }
                }),
                (error => { this.spinner.hideSpinner(); this.httpResponseService.httpErrorResponse$.next(error); }),
                (() => { this.spinner.hideSpinner(); })
            );
        }
    }

    setVisiblity(visible: boolean) {
        this.visible = visible;
        this.option.AdminOption.Visible = visible;
    }

    changeQuantity(increment: boolean, maxQuantity: number) {
        if (increment) {
            if (this.option !== undefined && this.option !== null
                && this.option.AdminOption !== undefined && this.option.AdminOption !== null
                && this.option.AdminOption.MaxQuantity !== undefined) {
                this.option.AdminOption.MaxQuantity = this.option.AdminOption.MaxQuantity + 1;
            }
        } else {
            if (this.option !== undefined && this.option !== null
                && this.option.AdminOption !== undefined && this.option.AdminOption !== null
                && this.option.AdminOption.MaxQuantity !== undefined) {
                this.option.AdminOption.MaxQuantity = ((this.option.AdminOption.MaxQuantity - 1) >= 0) ?
                    (this.option.AdminOption.MaxQuantity - 1) :
                    0;
            }
        }
    }

    getWebCategory(webCategoryId: number): AdminOptionCategory {
        if (this.categories !== undefined && this.categories !== null && this.categories.length > 0) {
            let webCat = this.categories.find(x => x.WebCategoryId === Number(webCategoryId));
            let other = this.categories.find(x => x.WebCategoryDesc.toUpperCase() === 'OTHER');

            if (webCat !== undefined && webCat !== null) {
                return webCat;
            }
            if (other !== undefined && other !== null) {
                return other;
            }
        }
        return new AdminOptionCategory();
    }

    changeProductLine() {
        this.spinner.showSpinner();
        let adminOptions: AdminOption[] = new Array<AdminOption>();
        if (this.HasChanged(this.option.ProductLineId)) {
            if (this.option !== undefined && this.option !== undefined) {

                adminOptions = this._buildAdminOptionForSave(this.option.ProductLineId);

                this.optionsAdminService.insUpdAdminOption(adminOptions, this.userId)
                    .subscribe(
                    (x => {
                        if (x !== undefined && x != null && x.Options !== undefined && x.Options !== null && x.Options.length > 0) {
                            // returned value from update is the option that was updated
                            let changedOption = x.Options.filter(o => o.OptionId === this.option.OptionId)[0];
                            this._savedItem = this.createUnreferencedOption(changedOption);
                            this.option = this.createUnreferencedOption(changedOption);
                            this.optionsAdminService.changedAdminOption$.next(this.createUnreferencedOption(changedOption));

                            // get the product line id associated with the product line code specified
                            let pl = this.option.ProductLines.find(
                                productLine => productLine.ProductLineCode === this.chosenProductLineCode
                            );
                            if (pl !== undefined) {
                                this.chosenProductLineId = pl.ProductLineId;
                            }

                            if (this._savedItem !== undefined && this._savedItem !== null) {
                                if (this.option.SubOptions !== null && this.option.SubOptions !== undefined) {
                                    this.option.SubOptions = this.option.SubOptions.filter(
                                        subOption => subOption.ProductLineId === Number(this.chosenProductLineId)
                                    );
                                    this.option.SubOptionCount = this.option.SubOptions.filter(
                                        subOption => subOption.ProductLineId === Number(this.chosenProductLineId)
                                    ).length;
                                } else {
                                    this.option.SubOptions = new Array<SubOption>();
                                    this.option.SubOptionCount = 0;
                                }
                            }
                            this.option.AdminOption = this.getUIAdminOption(this.option, Number(this.chosenProductLineId));

                            // this is set after update to correctly set current option product line
                            // let pl = this.option.ProductLines.find(pl => pl.ProductLineId === Number(this.chosenProductLineId));
                            if (pl !== undefined) {
                                this.option.ProductLineId = pl.ProductLineId;
                                this.option.ProductLineDesc = pl.ProductLineDescription;
                            }
                        }
                    }),
                    (error => { this.spinner.hideSpinner(); this.httpResponseService.httpErrorResponse$.next(error); }),
                    (() => { this.spinner.hideSpinner(); })
                    );
            }
        } else {
            var option = this.createUnreferencedOption(this._savedItem);
            this.option = option;

            // get the product line id associated with the product line code specified
            let pl = this.option.ProductLines.find(productLine => productLine.ProductLineCode === this.chosenProductLineCode);
            if (pl !== undefined) {
                this.chosenProductLineId = pl.ProductLineId;
            }

            if (this.option.SubOptions !== null && this.option.SubOptions !== undefined) {
                this.option.SubOptions = this.option.SubOptions !== undefined &&
                    this.option.SubOptions !== null &&
                    this.option.SubOptions.length > 0 ?
                    this.option.SubOptions.filter(so => so.ProductLineId === Number(this.chosenProductLineId)) :
                    new Array<SubOption>();
                this.option.SubOptions = this.option.SubOptions.filter(x => x.ProductLineId === Number(this.chosenProductLineId));
                this.option.SubOptionCount = this.option.SubOptions.filter(
                    x => x.ProductLineId === Number(this.chosenProductLineId)
                ).length;
            } else {
                this.option.SubOptions = new Array<SubOption>();
                this.option.SubOptionCount = 0;
            }
            this.option.AdminOption = this.getUIAdminOption(this.option, Number(this.chosenProductLineId));

            // this is set after update to correctly set current option product line
            // let pl = this.option.ProductLines.find(pl => pl.ProductLineCode === this.chosenProductLineCode);
            if (pl !== undefined) {
                this.option.ProductLineId = pl.ProductLineId;
                this.option.ProductLineDesc = pl.ProductLineDescription;
            }
            this.spinner.hideSpinner();
        }
    }

    generateProductLineUI(pl: ProductLine): string {
        let desc: string = '';
        if (pl !== undefined && pl != null) {
            if (pl.ProductLineDescription !== undefined && pl.ProductLineDescription !== null && pl.ProductLineDescription !== '') {

                desc = pl.ProductLineDescription.trim() + ((pl.ProductLineCode === null || pl.ProductLineCode === undefined) ?
                    '' :
                    '--' + pl.ProductLineCode.trim());
            }
        }
        return desc;
    }

    getUIAdminOption(option: Option, productLineId: number, productLineCode: string = null) {
        let adminOption = new AdminOption();

        // this selects the product line associated with any filtering from the main screen
        if (productLineCode !== null) {
            if (option.ProductLines.filter(pl => pl.ProductLineCode === productLineCode).length > 0) {
                productLineId = option.ProductLines.filter(pl => pl.ProductLineCode === productLineCode)[0].ProductLineId;
            }
        }

        if (option.AdminOptions !== undefined && this.option.AdminOptions !== null) {
            if (option.AdminOptions.length > 0) {
                if (option.AdminOptions.filter(ao => ao.ProductLineId === productLineId).length > 0) {
                    adminOption = option.AdminOptions.filter(ao => ao.ProductLineId === productLineId)[0];
                }
            }
        }
        // default the initial admin option description if the admin option associated with this product line is blank.
        adminOption.ProductLineId = adminOption.ProductLineId === null ? productLineId : adminOption.ProductLineId;
        adminOption.SubOptionId = adminOption.SubOptionId === null ? 0 : adminOption.SubOptionId;

        if (adminOption.CustomerDesc === '') { adminOption.CustomerDesc = this._savedItem.AdminOption.CustomerBaseDesc; }
        if (adminOption.CustomerBaseDesc === '') { adminOption.CustomerBaseDesc = this._savedItem.AdminOption.CustomerBaseDesc; }

        return adminOption;
    }

    createUnreferencedOption(option: Option):Option {
        var cleanOption = new Option();
        if (option !== undefined && option != null) {
            var newItem = Object.create(JSON.parse(JSON.stringify(option)));

            cleanOption.OptionId = newItem.OptionId;
            cleanOption.OptionNumber = newItem.OptionNumber;
            cleanOption.OptionDescription = newItem.OptionDescription;
            cleanOption.CategoryId = newItem.CategoryId;
            cleanOption.CategoryDesc = newItem.CategoryDesc;
            cleanOption.Commodity = newItem.Commodity;
            cleanOption.PartNumber = newItem.PartNumber;
            cleanOption.UnitPrice = newItem.UnitPrice;
            cleanOption.TotalPrice = newItem.TotalPrice;
            cleanOption.StandardPrice = newItem.StandardPrice;
            cleanOption.StandardOption = newItem.StandardOption;
            cleanOption.FrequencySequenceNumber = newItem.FrequencySequenceNumber;
            cleanOption.FrequencySequenceCode = newItem.FrequencySequenceCode;

            /// MyCustomHomes Stuff
            cleanOption.AdjustedUnitPrice = newItem.AdjustedUnitPrice;
            cleanOption.AdjustedTotalPrice = newItem.AdjustedTotalPrice;
            cleanOption.CustomUnitPrice = newItem.CustomUnitPrice;
            cleanOption.Quantity = newItem.Quantity;
            cleanOption.QuantityInfo = newItem.QuantityInfo;
            cleanOption.Note = newItem.Note;
            cleanOption.IsCustomPrice = newItem.IsCustomPrice;
            cleanOption.IsValidUnitPrice = newItem.IsValidUnitPrice;
            cleanOption.IsIncluded = newItem.IsIncluded;
            cleanOption.IsExcluded = newItem.IsExcluded;
            cleanOption.IncludePrice = newItem.IncludePrice;
            cleanOption.SelectedSubOptionDesc = newItem.SelectedSubOptionDesc;
            cleanOption.SelectedSubOption = newItem.SelectedSubOption;
            cleanOption.ModifiedBy = newItem.ModifiedBy;
            cleanOption.wasChanged = newItem.wasChanged;
            cleanOption.InvalidSubOption = newItem.InvalidSubOption;
            cleanOption.UIUnitPrice = newItem.UIUnitPrice;
            cleanOption.UnitPriceOverride = newItem.UnitPriceOverride;
            cleanOption.WasChanged = newItem.WasChanged;

            /// Options Admin Stuff
            cleanOption.PlantId = newItem.PlantId;
            cleanOption.PlantNumber = newItem.PlantNumber;
            cleanOption.SubOptionCount = newItem.SubOptionCount;
            cleanOption.AdminOptionCount = newItem.AdminOptionCount;
            cleanOption.IncludeExcludeCount = newItem.IncludeExcludeCount;
            cleanOption.MaxQuantity = newItem.MaxQuantity;
            cleanOption.Visible = newItem.Visible;
            cleanOption.ProductLineId = newItem.ProductLineId;
            cleanOption.ProductLineDesc = newItem.ProductLineDesc;
            cleanOption.ProductLineCode = newItem.ProductLineCode;


            cleanOption.AdminOption = newItem.AdminOption;

            cleanOption.AdminOptions = newItem.AdminOptions;
            cleanOption.ProductLines = newItem.ProductLines;
            cleanOption.IncludeExclude = newItem.IncludeExclude;
            cleanOption.SubOptions = newItem.SubOptions;

            // Default visibility to true for suboptions with no override (and thus a defaulted AdminOption)
            if(cleanOption.SubOptions) {
                cleanOption.SubOptions.filter(so => so.AdminOption.AdminOptionId === 0).forEach(so => so.AdminOption.Visible = true);
            }
        }
        return cleanOption;
    }

    _buildAdminOptionForSave(productLineId: number): AdminOption[] {
        let adminOptions: AdminOption[] = new Array<AdminOption>();
        let webCat = this.getWebCategory(this.option.AdminOption.WebCategoryId);

        if (this.option.AdminOption !== undefined && this.option.AdminOption !== null) {
            if ((this.option.AdminOption.CustomerCat !== null && this.option.AdminOption.CustomerCat.trim() !== '')
                || (this.option.AdminOption.CustomerDesc !== null && this.option.AdminOption.CustomerDesc.trim() !== '')
                || (this.option.AdminOption.WebCategoryId !== null && this.option.AdminOption.WebCategoryId !== 0)
                || (this.option.AdminOption.MaxQuantity !== null && this.option.AdminOption.MaxQuantity !== 0)
                || (this.option.AdminOption.AdminOptionId !== null && this.option.AdminOption.AdminOptionId !== 0)
                || (this.option.AdminOption.Visible !== null && this.option.AdminOption.Visible.valueOf.toString().trim() !== '')) {

                this.option.AdminOption.WebCategoryId = webCat.WebCategoryId;
                this.option.AdminOption.MaxQuantity = this.option.AdminOption.MaxQuantity;
                this.option.AdminOption.PlantId = this.option.PlantId;
                this.option.AdminOption.ProductLineId = productLineId;
                this.option.AdminOption.OptionId = this.option.OptionId;
                this.option.AdminOption.OptionNumber = this.option.OptionNumber;
                this.option.AdminOption.AdminOptionId = this.option.AdminOption.AdminOptionId !== null ?
                    this.option.AdminOption.AdminOptionId :
                    0;
                this.option.AdminOption.CustomerDesc = this.option.AdminOption.CustomerDesc;
                this.option.AdminOption.CustomerCat = webCat.WebCategoryDesc;
                this.option.AdminOption.MaxQuantity = this.option.AdminOption.MaxQuantity;
                this.option.AdminOption.Visible = this.option.AdminOption.Visible === false ? false : true;
                adminOptions.push(this.option.AdminOption);
            }
        }

        if (this.option.SubOptions !== undefined && this.option.SubOptions !== null && this.option.SubOptions.length > 0) {
            this.option.SubOptions.forEach((so) => {
                const savedSuboption = this._savedItem.SubOptions.find(suboption => suboption.SubOptionId === so.SubOptionId);

                if (so.AdminOption !== undefined && so.AdminOption !== null) {
                    if ((so.AdminOption.CustomerCat !== null && so.AdminOption.CustomerCat.trim() !== '')
                        || (so.AdminOption.CustomerDesc !== null && so.AdminOption.CustomerDesc.trim() !== '')
                        || (so.AdminOption.WebCategoryId !== null && so.AdminOption.WebCategoryId !== 0)
                        || (so.AdminOption.MaxQuantity !== null && so.AdminOption.MaxQuantity !== 0)
                        || (so.AdminOption.AdminOptionId !== null && so.AdminOption.AdminOptionId !== 0)
                        || (so.AdminOption.Visible !== savedSuboption.AdminOption.Visible)) {

                        so.AdminOption.WebCategoryId = webCat.WebCategoryId;
                        so.AdminOption.PlantId = this.option.PlantId;
                        so.AdminOption.ProductLineId = Number(productLineId);
                        so.AdminOption.OptionId = this.option.OptionId;
                        so.AdminOption.OptionNumber = this.option.OptionNumber;
                        so.AdminOption.SubOptionId = so.SubOptionId;
                        so.AdminOption.AdminOptionId = this.option.AdminOption.AdminOptionId !== null ?
                            this.option.AdminOption.AdminOptionId :
                            0;
                        so.AdminOption.CustomerDesc = so.AdminOption.CustomerDesc;
                        so.AdminOption.CustomerCat = webCat.WebCategoryDesc;
                        adminOptions.push(so.AdminOption);
                    }
                }
            });
        }

        return adminOptions;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/options-admin-aside/options-admin-aside.component.ts